<template>
  <div v-if="label" class="promotion-label">
    <span :class="labelClass">{{ label }}</span>

  </div>
</template>

<script>
export default {
  props: {
    promotion: {
      type: Array,
      required: true
    }
  },
  computed: {
    label() {
      const searchKey = this.promotion[0].searchKey.toLowerCase();
      if (searchKey === 'campaign' || searchKey === 'new' || searchKey === 'special') {
        return this.promotion[0].name;
      } else {
         return null;
      }
    },
    labelClass() {
      return this.promotion[0].searchKey ? this.promotion[0].searchKey.toLowerCase() : '';
    }
  }
}
</script>

<style lang="scss" scoped>
.promotion-label {
  display: flex;
  align-items: center;

  // flat tab on top of the product frame
  span {
    color: white;
    font-weight: bold;
    font-size: 12px;
    line-height: 1.4;
    letter-spacing: 0.5px;
    padding: 2px 12px;
    border-radius: 6px 6px 0 0;
    white-space: nowrap;

    &.campaign {
      background-color: #ffa500;
    }

    &.new {
      background-color: #2196F3;
    }

    &.special {
      background-color: #35c1b6;
    }
  }
}

// product row: tab sits above the row frame
.productcompact .promotion-label {
  position: absolute;
  top: -2px;
  left: -4px;
  transform: translateY(-100%);
  margin: 0;
  z-index: 5;
}

// size card: tab is the card header, always as wide as the card
.variantItem {
  .promotion-label {
    order: -1;
    align-self: stretch;
    // cancel the card padding and border so the tab covers the card's top edge
    margin: calc(-0.4rem - 2px) calc(-0.4rem - 2px) 0.4rem;

    span {
      flex: 1;
      text-align: center;
      white-space: normal;
      border-radius: 4px 4px 0 0;
    }
  }
}
</style>